
import millieApi from 'app/apis/millie';

const Types = {
  GET: 'BRACKETS_GET',
  GET_VOTE_RECORD: 'BRACKETS_GET_VOTE_RECORD',
};

const Actions = {

  get: (id) => {
    const promise = millieApi.bracketsGet(id);
    return { type: Types.GET, _entities: ['bracket', 'bracketGames', 'nonprofits', 'fund'], promise };
  },

  getVoteRecord: (id) => {
    const promise = millieApi.bracketsGetVoteRecord(id);
    return { type: Types.GET_VOTE_RECORD, _entities: ['bracketVoteRecord'], promise };
  },

};

export {
  Types,
};

export default Actions;
